import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import Form from './form';
import {
  getHomework,
  saveHomework,
  fetchHomeworkFormDatas,
  updateScoreHomework,
} from '../../../../redux/actions/materiaPeriodoActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import debounce from '../../../../helpers/debounce';

class HomeworkContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tarea: {
        descripcion: '',
        tareaMateriaAlumnos: [],
        tipoTarea: { value: 0, label: '-' },
      },
      tiposTareas: [],
      loading: false,
      filterValue: '',
      sortColumn: 'apellido',
      sortType: 'desc',
    };

    this.debouncedAutoSaveScore = debounce(this.autoSaveScore, 500);
  }

  componentDidMount() {
    this.fetchDatasList();
  }

  fetchDatasList = () => {
    this.setState({
      loading: true,
    });

    fetchHomeworkFormDatas({
      onSuccess: ({ TipoTarea = [] }) => {
        const { id } = this.props;
        const { tarea = {} } = this.state;

        this.setState({
          tiposTareas: TipoTarea,
          loading: false,
          tarea: {
            ...tarea,
            tipoTarea: TipoTarea.find(({ value }) => value === 1),
          },
        });

        this.fetchCurrentRecord(id);
      },
      onError: () => {
        this.setState({
          tiposTareas: [],
          loading: false,
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  fetchCurrentRecord = (id) => {
    this.setState({ loading: true });

    if (!id) {
      const { tarea = {} } = this.state;
      this.setState({
        loading: false,
        tarea: {
          ...tarea,
          id: 0,
          descripcion: '',
        },
      });

      return;
    }

    getHomework({
      id,
      onSuccess: (tarea) => {
        const { fechaEntrega } = tarea;
        this.setState({
          loading: false,
          tarea: {
            ...tarea,
            ...{
              fechaEntrega: fechaEntrega.split('T')[0],
            },
          },
        });
      },
      onError: (error) => {
        this.setState({ loading: false });

        if (error && error.status === 404) {
          createErrorMessage('La tarea de clase no existe');
        } else {
          createErrorMessage('Error al intentar cargar los datos de la tarea de clase');
        }
      },
    });
  }

  handleSubmit = (values) => {
    if (!values) return;

    this.setState({ loading: true });

    const {
      id,
      materiaPeriodoId,
      descripcion,
      fechaEntrega,
      tipoTarea: { value: tipoTarea },
      puntajeTotal,
      porcentajePesoMateria,
      deleted,
    } = values;

    const { utilizaPorcentajePesoMateria } = this.props;

    saveHomework({
      paylaod: {
        id,
        materiaPeriodoId,
        descripcion,
        fechaEntrega,
        tipoTarea,
        puntajeTotal,
        porcentajePesoMateria: utilizaPorcentajePesoMateria ? (porcentajePesoMateria || 0) : 0,
        deleted,
      },
      onSuccess: (tareaId) => {
        this.setState({ loading: false });

        this.fetchCurrentRecord(tareaId);
        createSuccessMessage('Tarea de clase guardada exitosamente');
      },
      onError: (error) => {
        this.setState({ loading: false });

        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la tarea de clase');
        }
      },
    });
  }

  handleOnBack = () => {
    const { onHideForm } = this.props;
    onHideForm();
  }

  handleChangeText = ({
    name,
    target,
    numeroDocumento,
  }) => {
    const value = target.type === 'number'
      ? Number(target.value)
      : `${target.value}`.trim();

    if (numeroDocumento) {
      const { tarea } = this.state;
      const items = tarea[name];

      const newArray = [...items];
      const index = newArray.findIndex(item => item.numeroDocumento === numeroDocumento);

      newArray[index] = {
        ...newArray[index],
        ...{
          [target.name.split('.')[1]]: value,
        },
      };

      this.setState({
        tarea: {
          ...tarea,
          [name]: newArray,
        },
      });

      this.debouncedAutoSaveScore(newArray[index]);

      return;
    }

    this.setState(prev => ({
      tarea: {
        ...prev.tarea,
        ...{
          [target.name]: value,
        },
      },
    }));
  };

  handleChangeSelect = ({ option, name }) => {
    const { tarea } = this.state;

    const newState = {
      ...tarea,
      [name]: option,
    };

    if (option.value === 2) {
      newState.puntajeTotal = 1;
      newState.porcentajePesoMateria = '';
    }

    this.setState({ tarea: newState });
  };

  handleSort = ({ sortColumn, sortType }) => {
    this.setState({
      sortColumn,
      sortType: sortType === 'desc' ? 'asc' : 'desc',
    });
  };

  handleFilterChangeText = ({ target: { value } }) => {
    this.setState({ filterValue: value });
  };

  transformText = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  getTareaMateriaAlumnos = () => {
    const {
      filterValue = '',
      sortColumn,
      sortType,
      tarea: { tareaMateriaAlumnos = [] },
    } = this.state;

    const filter = this.transformText(filterValue);

    const result = tareaMateriaAlumnos
      .filter(tma => (
        this.transformText(tma.numeroDocumento).includes(filter)
        || this.transformText(tma.nombre).includes(filter)
        || this.transformText(tma.apellido).includes(filter)
      ))
      .sort((a, b) => (
        sortType !== 'asc' ? a[sortColumn].localeCompare(b[sortColumn]) : b[sortColumn].localeCompare(a[sortColumn])
      ));

    return result;
  };

  autoSaveScore = (row) => {
    if (!row) return;

    const {
      id,
      inscripcionMateriaId,
      puntajeObtenido,
      tareaMateriaId,
    } = row;

    updateScoreHomework({
      id,
      inscripcionMateriaId,
      puntajeObtenido,
      tareaMateriaId,
    }, {
      onSuccess: () => {
        createSuccessMessage('Puntaje actualizado exitosamente.');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar el puntaje.');
        }
      },
    });
  };

  render() {
    const {
      id,
      materiaPeriodoId,
      utilizaPorcentajePesoMateria,
    } = this.props;

    const {
      tarea,
      tiposTareas = [],
      loading,
      filterValue,
      sortColumn,
      sortType,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} tarea de clase
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              tarea de clase
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {
              loading ? <LoadingSpinner />
                : (
                  <Form
                    {...tarea}
                    materiaPeriodoId={materiaPeriodoId}
                    tiposTareas={tiposTareas}
                    utilizaPorcentajePesoMateria={utilizaPorcentajePesoMateria}
                    tareaMateriaAlumnos={this.getTareaMateriaAlumnos()}
                    filterValue={filterValue}
                    onSubmit={this.handleSubmit}
                    onBack={this.handleOnBack}
                    loading={loading}
                    initialValues={tarea}
                    sortColumn={sortColumn}
                    sortType={sortType}

                    handleChangeText={this.handleChangeText}
                    onChangeSelect={this.handleChangeSelect}
                    handleSort={this.handleSort}
                    handleFilterChangeText={this.handleFilterChangeText}

                    showSpinner={this.showSpinner}
                    enableReinitialize
                  />
                )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

HomeworkContainer.propTypes = {
  id: PropTypes.number.isRequired,
  materiaPeriodoId: PropTypes.number.isRequired,
  utilizaPorcentajePesoMateria: PropTypes.bool.isRequired,
  finCalificarTareas: PropTypes.string.isRequired,
  onHideForm: PropTypes.func.isRequired,
};

export default HomeworkContainer;
